export default "__VITE_ASSET__DLAB83pW__"